var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createUbiProd1Impression, } from '@spotify-internal/event-definitions/es5/events/createUbiProd1Impression';
import { createUbiProd1ImpressionNonAuth, } from '@spotify-internal/event-definitions/es5/events/createUbiProd1ImpressionNonAuth';
import { getParentPath, getParentSpecModes, getParentSpecVersions, getPathProps, } from '../utils/EventUtils';
import { EMPTY_STRING } from '../constants';
import { v4 as uuid } from 'uuid';
export var ImpressionEventConverter = (function impressionFn() {
    function createGabitoEvent(event, authenticationProvider, ubiContextualProviders) {
        var _a, _b, _c, _d, _e;
        var pathProps = getPathProps(event.location.pathNodes);
        var parentPath = getParentPath(event.parentAbsoluteLocation);
        var parentPathProps = getPathProps(parentPath);
        var parentSpecVersions = getParentSpecVersions(event.parentAbsoluteLocation);
        var parentSpecModes = getParentSpecModes(event.parentAbsoluteLocation);
        var baseEvent = {
            annotator_configuration_version: EMPTY_STRING,
            annotator_version: EMPTY_STRING,
            app: event.app,
            element_path_ids: pathProps.element_path_ids,
            element_path_names: pathProps.element_path_names,
            element_path_pos: pathProps.element_path_pos,
            element_path_reasons: pathProps.element_path_reasons,
            element_path_uris: pathProps.element_path_uris,
            generator_version: event.generatorVersion,
            impression_id: uuid(),
            parent_modes: parentSpecModes,
            parent_path_ids: parentPathProps.element_path_ids,
            parent_path_names: parentPathProps.element_path_names,
            parent_path_pos: parentPathProps.element_path_pos,
            parent_path_reasons: parentPathProps.element_path_reasons,
            parent_path_uris: parentPathProps.element_path_uris,
            parent_specification_versions: parentSpecVersions,
            specification_version: event.specificationVersion,
            specification_mode: event.specificationMode
        };
        if (ubiContextualProviders.pageInstanceIdProvider) {
            baseEvent = __assign(__assign({}, baseEvent), { page_instance_id: ubiContextualProviders.pageInstanceIdProvider.getPageInstanceId() ||
                    null });
        }
        if (ubiContextualProviders.playbackIdProvider) {
            baseEvent = __assign(__assign({}, baseEvent), { playback_id: ((_a = ubiContextualProviders.playbackIdProvider) === null || _a === void 0 ? void 0 : _a.getPlaybackId()) || null });
        }
        if (ubiContextualProviders.playContextUriProvider) {
            baseEvent = __assign(__assign({}, baseEvent), { play_context_uri: ((_b = ubiContextualProviders.playContextUriProvider) === null || _b === void 0 ? void 0 : _b.getPlayContextUri()) ||
                    null });
        }
        if (ubiContextualProviders.pageUriProvider) {
            baseEvent = __assign(__assign({}, baseEvent), { page_uri: ((_c = ubiContextualProviders.pageUriProvider) === null || _c === void 0 ? void 0 : _c.getPageUri()) || null });
        }
        if (ubiContextualProviders.pageIdProvider) {
            baseEvent = __assign(__assign({}, baseEvent), { page_id: ((_d = ubiContextualProviders.pageIdProvider) === null || _d === void 0 ? void 0 : _d.getPageId()) || null });
        }
        if (authenticationProvider.isAuthenticated()) {
            return createUbiProd1Impression(baseEvent);
        }
        var nonAuthImpressionEvent = __assign(__assign({}, baseEvent), { flow_id: ((_e = ubiContextualProviders.flowIdProvider) === null || _e === void 0 ? void 0 : _e.getFlowId()) || null });
        return createUbiProd1ImpressionNonAuth(nonAuthImpressionEvent);
    }
    return { createGabitoEvent: createGabitoEvent };
})();
//# sourceMappingURL=ImpressionEventConverter.js.map